import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavSubItemComponent } from '../nav-sub-item.component';
import { Router } from '@angular/router';
import { ProductsSubNavItemViewModel } from './products-sub-nav-item-view-model';

@Component({
  selector: 'app-products-sub-nav-item',
  templateUrl: './products-sub-nav-item.component.html',
  styleUrls: ['./products-sub-nav-item.component.scss', '../nav-sub-item.component.scss'],
  providers: [ProductsSubNavItemViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductsSubNavItemComponent extends NavSubItemComponent {
  constructor(
    public override viewModel: ProductsSubNavItemViewModel,
    router: Router
  ) {
    super(viewModel, router);
  }
}
